import React from "react";
import styled, { css } from "styled-components";

// Context
import { useFormSelectDialog } from "core/FormSelectDialog/context/useFormSelectDialog";

// styles
import colors from "core/colors";
export const DisplayTextStyled = styled.div`
    color: ${colors.secondary.oolong};

    ${({ $labelDisplay }) =>
        $labelDisplay === "block"
            ? css`
                  flex: 1 1 0;
                  min-width: 0;
                  display: block;
                  text-align: left;
                  align-self: center;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
              `
            : css`
                  flex: 0 0 auto;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
              `}
`;

// component
export const DisplayText = () => {
    const { selectedOption, controlLabelOverride, labelDisplay } =
        useFormSelectDialog();

    const displaytext =
        controlLabelOverride ||
        selectedOption.controlLabelOverride ||
        selectedOption.label;

    return (
        <DisplayTextStyled $labelDisplay={labelDisplay}>
            {displaytext}
        </DisplayTextStyled>
    );
};

export default DisplayText;
